export default ({
	propertyOptIn,
	optedInCountries,
	countryCodeFromGeoIPCookie,
	willForceAllInPricing,
}) =>
	willForceAllInPricing || propertyOptIn || optedInCountries.includes(countryCodeFromGeoIPCookie);
